/**
 * Created by Rakesh Peela
 * Date: 28-Nov-2019
 * Time: 11:07 AM
 */

export const REPORT_PENDING = "REPORT_PENDING";
export const REPORT_FAILED = "REPORT_FAILED";
export const REPORT_SUCCESS = "REPORT_SUCCESS";